export default __webpack_public_path__ + "static/media/edit.d7cc2c8c.svg";